import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { Trophy, Sparkles, ArrowRight } from "lucide-react";

const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const fmt = (iso) => { try { return new Date(iso).toLocaleString("en-IN", { day:"2-digit", month:"short", year:"numeric" }); } catch { return "—"; } };

export default function Editions() {
  const [editions, setEditions] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/editions"); setEditions(data.editions); } catch {}
    })();
  }, []);

  return (
    <div className="App" data-testid="editions-page">
      <Navbar />
      <div className="relative">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-16 lg:py-24">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start">
              <div className="label-eyebrow mb-3 inline-flex items-center gap-2"><Sparkles className="w-3 h-3 text-brand" /> The Series</div>
              <h1 className="font-display text-5xl sm:text-6xl text-white leading-none tracking-tight">Every <span className="text-brand">IdeaThon</span>,<br />in one place.</h1>
              <p className="text-gray-400 mt-5 max-w-sm leading-relaxed">A growing archive of every NoobSync Innovate hackathon — past, present, and upcoming. Each edition carries a unique theme.</p>
            </div>

            <div className="lg:col-span-8 grid md:grid-cols-2 gap-4">
              {editions.length === 0 && (
                <div className="card-surface text-gray-500 md:col-span-2" data-testid="editions-empty">
                  <div className="font-display text-2xl text-white">No editions launched yet.</div>
                  <p className="mt-2 text-sm">The first IdeaThon is being prepared. Once it goes live, every edition — current, past, and upcoming — will be archived here.</p>
                </div>
              )}
              {editions.map((e, i) => (
                <div key={e.id} className={`card-surface card-hover ${e.active ? "border-l-2 border-brand md:col-span-2" : ""}`} data-testid={`edition-${i}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono text-xs text-brand uppercase tracking-widest">{e.edition || "—"}</span>
                    {e.theme && <span className="badge badge-invited">Theme · {e.theme}</span>}
                    {e.active && <span className="badge badge-accepted">current</span>}
                    {!e.active && e.status === "completed" && <span className="badge badge-upcoming">closed</span>}
                  </div>
                  <div className="font-display text-2xl text-white mt-2">{e.name}</div>
                  {e.tagline && <p className="text-sm text-gray-400 mt-1">{e.tagline}</p>}
                  <div className="text-xs font-mono text-gray-500 mt-3">
                    {fmt(e.r1_open_at)} → {fmt(e.r2_close_at)}
                  </div>
                </div>
                {e.active && (
                  <Link to="/" className="btn-secondary !py-2 !px-3 text-xs flex items-center gap-2">
                    Visit <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                )}
              </div>

              {e.judging_complete && e.winners?.length > 0 && (
                <div className="mt-5 pt-5 border-t border-white/5">
                  <div className="label-eyebrow mb-3 flex items-center gap-2"><Trophy className="w-3 h-3 text-brand" /> Winners</div>
                  <div className="grid sm:grid-cols-3 gap-3">
                    {e.winners.map((w, j) => (
                      <div key={j} className="border border-white/10 p-3" data-testid={`edition-${i}-winner-${w.rank}`}>
                        <div className="label-eyebrow">{w.rank_label}</div>
                        <div className="font-display text-base text-white mt-1">{w.team_name || "—"}</div>
                        {w.project_title && <div className="text-xs text-gray-500 mt-0.5 truncate">{w.project_title}</div>}
                        <div className="font-display text-brand text-sm mt-2">{formatINR(w.prize_amount)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {e.results_announced && e.slug && (
                <Link
                  to={`/results/${e.slug}`}
                  className="btn-secondary !py-2.5 mt-5 w-full flex items-center justify-center gap-2 group"
                  data-testid={`edition-${i}-results-link`}
                >
                  <Trophy className="w-4 h-4 text-brand" strokeWidth={1.5} />
                  View full results &amp; team profiles
                  <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
                </Link>
              )}
            </div>
          ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
